<template>
  <div>
    <slide-hero/>
    <slide-feature/>
    <slide-type/>
    <slide-package/>
    <slide-recommend/>
    <slide-material/>
    <slide-valiation/>
  </div>
</template>

<script>
import SlideHero from '@/components/index/SlideHero.vue'
import SlideFeature from '@/components/index/SlideFeature.vue'
import SlideType from '@/components/index/SlideType.vue'
import SlidePackage from '@/components/index/SlidePackage.vue'
import SlideRecommend from '@/components/index/SlideRecommend.vue'
import SlideMaterial from '@/components/index/SlideMaterial.vue'
import SlideValiation from '@/components/index/SlideValiation.vue'

export default {
  name: 'home',
  components: {
    SlideHero,
    SlideFeature,
    SlideType,
    SlidePackage,
    SlideRecommend,
    SlideMaterial,
    SlideValiation
  }
}
</script>